import { SelectedSuggestion } from '../types'

export const getSearchTerm = ({
  selectedSuggestion,
  searchTerm,
  correctedSearchTerm,
}: {
  selectedSuggestion?: SelectedSuggestion
  searchTerm?: string
  correctedSearchTerm?: string
}) => {
  const suggestedTerm = selectedSuggestion ? selectedSuggestion.label : ' '

  return {
    term: correctedSearchTerm || searchTerm || suggestedTerm,
    isSearchTermBlank: !selectedSuggestion && !searchTerm,
  }
}
